import ModalNewQuestionComponent from './containers/modalNewQuestionComponent'

export { default as ModalNewQuestionLayout } from './components/modalNewQuestionLayout' 

export default ModalNewQuestionComponent